import { CartAddEvent, ThemeEvents } from '@theme/events';

const sectionName = 'madam-cart-offer';
let epoch = 0;
let cache = null;
let pending = null;
let refreshTimer;
let adding = false;
const root = () => window.Shopify?.routes?.root || '/';
const parseContent = html => new DOMParser().parseFromString(html, 'text/html').querySelector('.mc-offer-content')?.outerHTML || '';
const quotes = ['Gönül bir kılıfa sığmaz ♡', 'Hayat senin, tarz senin; fırsat bizim!', 'Kılıf güzel, hayat güzel; üçlü olunca daha güzel ♡', 'Sevdiğin rengi buldun, yanına bir dost daha koy!', 'Güzel kılıf yalnız gezmez ♡'];
let quoteIndex = Math.floor(Math.random() * quotes.length);
const visible = element => !element.closest('cart-drawer-component') || !!element.closest('dialog')?.open;
const schedule = () => {
  clearTimeout(refreshTimer);
  refreshTimer = setTimeout(() => document.querySelectorAll('mc-cart-offer').forEach(element => element.refresh()), 90);
};
async function content() {
  if (cache?.epoch === epoch) return cache.html;
  if (pending?.epoch === epoch) return pending.promise;
  const version = epoch;
  const url = new URL(window.location.href);
  url.searchParams.delete('sections');
  url.searchParams.set('section_id', sectionName);
  const promise = fetch(url, { credentials: 'same-origin', cache: 'no-store' })
    .then(response => {
      if (!response.ok) throw new Error('Öneriler yüklenemedi.');
      return response.text();
    })
    .then(html => {
      const value = parseContent(html);
      if (version === epoch) cache = { epoch: version, html: value };
      return value;
    })
    .finally(() => { if (pending?.epoch === version) pending = null; });
  pending = { epoch: version, promise };
  return promise;
}
function changed(event) {
  if (event.detail?.data?.didError) return;
  epoch++;
  const html = event.detail?.data?.sections?.[sectionName];
  cache = typeof html === 'string' ? { epoch, html: parseContent(html) } : null;
  schedule();
}
document.addEventListener(ThemeEvents.cartUpdate, changed);
document.addEventListener(ThemeEvents.discountUpdate, changed);
document.addEventListener('dialog:open', event => {
  if (event.target.matches('cart-drawer-component')) {
    quoteIndex = (quoteIndex + 1 + Math.floor(Math.random() * (quotes.length - 1))) % quotes.length;
    document.querySelectorAll('[data-offer-quote]').forEach(el => el.textContent = quotes[quoteIndex]);
    schedule();
  }
}, true);

class MadamCartOffer extends HTMLElement {
  static observedAttributes = ['data-cart-stamp'];
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== null && oldValue !== newValue) {
      epoch++; cache = null; schedule();
    }
  }
  connectedCallback() {
    if (!this.bound) {
      this.bound = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-offer-next]');
        if (!button) return;
        const group = button.closest('[data-offer-group]');
        const cards = [...group.querySelectorAll('[data-offer-form]')];
        const pages = Math.ceil(cards.length / 5);
        this.offerPage = ((this.offerPage || 0) + 1) % pages;
        cards.forEach((card, i) => card.hidden = Math.floor(i / 5) !== this.offerPage);
        const status = group.querySelector('[data-offer-page]');
        if (status) status.textContent = (this.offerPage + 1) + ' / ' + pages;
      });
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-offer-select]');
        if (!select) return;
        const option = select.selectedOptions[0];
        const form = select.closest('form');
        form.querySelector('[data-offer-price]').textContent = option.dataset.price;
        form.querySelectorAll('[data-offer-link]').forEach(link => link.href = option.dataset.url);
        const image = form.querySelector('img');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
        }
        form.querySelector('[data-offer-error]').textContent = '';
      });
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-offer-form]');
        if (!form) return;
        event.preventDefault();
        event.stopPropagation();
        this.add(form);
      });
    }
    this.dialogObserver?.disconnect();
    const dialog = this.closest('dialog');
    if (dialog) {
      this.dialogObserver = new MutationObserver(() => { if (dialog.open) schedule(); });
      this.dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }
    schedule();
  }
  disconnectedCallback() { this.dialogObserver?.disconnect(); }
  async refresh() {
    if (!this.isConnected || !visible(this)) return;
    const version = epoch;
    try {
      const html = await content();
      this.retryPending = false;
      if (!this.isConnected || version !== epoch) return;
      if (this.renderedHTML !== html || !this.firstElementChild) {
        this.innerHTML = html;
        this.renderedHTML = html;
        this.offerPage = 0;
        const quote = this.querySelector('[data-offer-quote]');
        if (quote) quote.textContent = quotes[quoteIndex];
      }
    } catch {
      if (!this.retryPending) {
        this.retryPending = true;
        setTimeout(() => {
          if (this.isConnected && visible(this)) this.refresh();
        }, 1200);
      }
    }
  }
  async add(form) {
    if (adding) return;
    adding = true;
    const button = form.querySelector('button[type="submit"]');
    const select = form.querySelector('[name="id"]');
    const error = form.querySelector('[data-offer-error]');
    error.textContent = '';
    button.disabled = true;
    select.disabled = true;
    button.textContent = 'Ekleniyor…';
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 4);
    sections.push(sectionName);
    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: select.value, quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Ürün eklenemedi.');
      document.dispatchEvent(new CartAddEvent(data, 'madam-cart-offer', { source: 'madam-cart-offer', sections: data.sections }));
      button.textContent = 'Eklendi ✓';
    } catch (failure) {
      error.textContent = failure instanceof TypeError ? 'Bağlantı kesildi. Tekrar eklemeden önce sepetini kontrol et.' : failure.message;
    } finally {
      adding = false;
      button.disabled = false;
      select.disabled = false;
      if (button.textContent !== 'Eklendi ✓') button.textContent = '+ Ekle';
    }
  }
}
if (!customElements.get('mc-cart-offer')) customElements.define('mc-cart-offer', MadamCartOffer);
